export function clamp(v)
{
    return v < 0 ? 0 : v > 1 ? 1 : v;
}
